import React from "react";
import ReactDOM from "react-dom/client";
// Self-hosted display face. Bricolage Grotesque is the current display font
// (experiment/display-font-bricolage): the wght axis only — no opsz, no wdth, no
// italic. Instrument Serif stays imported so the token can be switched straight back.
import "@fontsource-variable/bricolage-grotesque/wght.css";
import "@fontsource/instrument-serif/400.css";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
